import { NgModule } from '@angular/core';
import { S143gS143m01Component } from './s143g-s143m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S143gS143m01Component]
})
export class S143gModule { }

